module.exports = __webpack_public_path__ + "media/images/flt-og-image-6b4fa6e5c41da2db39892ef418a3213c.png";